
import { Outlet } from 'react-router-dom'

export default function LoginDecorator({ children }) {
  return (
    <div className="w-full h-full my-auto flex justify-center items-center">
      {children}
      <Outlet />
    </div>
  )
}
